<mat-card class="overview-card">
	<mat-card-header class="overview-card-header">
		<h5 class="text-center font-weight-bold ma-1">
			{{ aircraftModel.name }}
			<span class="readonly-label"></span>
		</h5>
	</mat-card-header>
	<mat-card-content class="card-content no-padding ">
		<div class="aircraft-details">
			<div class="readonly-label">
				Created: <span class="data">{{ aircraftModel.effectiveStart | date: 'MMMM, y' }}</span>
			</div>
			<div class="end-date readonly-label">
				Archived:
				<span class="data">{{
					aircraftModel.effectiveEnd ? (aircraftModel.effectiveEnd | date: 'MMMM, y') : 'None'
				}}</span>
			</div>
		</div>
	</mat-card-content>
	<mat-card-actions class="card-action-box">
		<button
			type="button"
			color="primary"
			mat-button
			(click)="navigate(aircraftModel.aircraftModelId)"
			*ngIf="!this.isArchived"
		>
			Edit
		</button>
		<button
			type="button"
			color="primary"
			mat-button
			(click)="navigateArchived(aircraftModel.aircraftModelId)"
			*ngIf="isArchived"
		>
			View
		</button>
	</mat-card-actions>
</mat-card>
